'use strict';

var stringify = require('./stringify');
var parse = require('./parse');
var formats = require('./formats');

module.exports = {
    formats: formats,
    parse: parse,
    stringify: stringify
};



//////////////////
// WEBPACK FOOTER
// /Users/Nathan/Desktop/Computing Sciences/dissertation/pairgo/pairgo-ng/~/qs/lib/index.js
// module id = ../../../../qs/lib/index.js
// module chunks = 4